// extracted by mini-css-extract-plugin
export default {"ourProjects":"ourProjects_ourProjects__ZadpA","top":"ourProjects_top__sgs9S","list":"ourProjects_list__nBhQi"};